export default __webpack_public_path__ + "static/media/eagle-systems-logo.9f49e563.png";